import { get, post } from 'helpers/api';
import types from './types';

// Authentication
export const getUser = auth_key => {
  return (dispatch, getState) => {
    const {
      authentication: { isAuthenticationProcess, isAuthenticationSuccess, isAuthenticationError },
    } = getState();
    if (!isAuthenticationProcess) {
      return dispatch(getNewUser(auth_key));
    } else {
      return false;
    }
  };
};

export const getNewUser = auth_key => {
  return dispatch =>
    get('/user', {
      data: {},
      headers: { Authorization: `Bearer ${auth_key}` },
      before: () => dispatch(getAuthenticationStart()),
      success: authentication => dispatch(getAuthenticationSuccess(authentication)),
      error: err => dispatch(getAuthenticationError(err)),
    });
};

const getAuthenticationStart = () => {
  return {
    type: types.AUTHENTICATION_START,
  };
};

export const getAuthenticationSuccess = authentication => {
  return {
    type: types.AUTHENTICATION_SUCCESS,
    authentication,
  };
};

const getAuthenticationError = err => {
  return {
    type: types.AUTHENTICATION_ERROR,
    authentication: { error: err.message },
  };
};



// WEBPACK FOOTER //
// state/authentication/actions.js